import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { OBS_FILE_NAME } from '../../utils/constants';

const useObservationData = () => {
  const obsData = useQuery({
    queryKey: ['observationData'],
    queryFn: async () => {
      const { data } = await axios.get(
        `${process.env.REACT_APP_CLOUDFRONT_URL}/${OBS_FILE_NAME}`
      );
      return data;
    },
    select: (data) => {
      return data.filter(d => d !== null);
    },
  });

  return obsData;
};

export default useObservationData;
